// Rider Related Endpoints
import { POOL, FLEXIGO_V2, UMNG, FLEXIGO_V3, BASEURL } from './base';

export const rider = {
  requests: `${POOL}/flexiride-pool/requests`,
  recurringRequests: `${POOL}/flexiride-pool/recurring-requests`,
  requestsWithTracking: `${POOL}/flexiride-pool/requests-with-tracking`,
  cancelRequest: `${POOL}/flexiride-pool/requests/:requestId/cancel`,
  cancelRecurringRequest: `${POOL}/flexiride-pool/requests/:requestId/cancel-all`,
  updateRequest: `${POOL}/flexiride-pool/requests/:requestId/update`,
  updateRecurringRequest: `${POOL}/flexiride-pool/requests/:recurringId/update-all`,
  approveOffer: `${POOL}/flexiride-pool/requests/:requestId/approve-offer`,
  rejectOffer: `${POOL}/flexiride-pool/requests/:requestId/reject-offer`,
  myAddress: `${UMNG}/saved-locations?locationType=PERSONAL_LOCATION`,
  savedLocation: `${UMNG}/saved-locations`,
  editLocation: `${UMNG}/saved-locations/:savedLocationId`,
  deleteLocation: `${UMNG}/saved-locations/:savedLocationId`,
  homeAddress: `${FLEXIGO_V2}/personnel/home/update`,
  sendSms: `${BASEURL}register/personnel/sendSms`,
  verifyPhoneNumber: `${BASEURL}register/personnel/verifyPhoneNumber`,
};

export const feedback = {
  getAll: `${FLEXIGO_V3}/personnel/ticket/list`,
  getComments: (id) => `${FLEXIGO_V3}/personnel/ticket/${id}/comments`,
  topics: `${FLEXIGO_V3}/tickets/topics`,
  newFeedback: `${FLEXIGO_V3}/personnel/ticket/new`,
  routes: `${FLEXIGO_V3}/tickets/shuttle-vanpool-routes?destinationId=:id`,
  updateComment: (id) => `${FLEXIGO_V3}/personnel/ticket/${id}/addComment`,
  fileUpload: `${FLEXIGO_V3}/personnel/file/uploadMany`,
  getTrips: (date) => `${FLEXIGO_V3}/tickets/flexiride-trips?startDay=${date}`,
  getVehicles: (date) => `${FLEXIGO_V3}/tickets/flexicar-vehicles?startDay=${date}`,
};

export const wallet = {
  balanceWithTransactions: `${BASEURL}rest/wallet/balance-with-transactions`,
  calculateTopup: `${BASEURL}rest/wallet/calculate-topup-amount`,
  balance: `${BASEURL}rest/wallet/balance`,
  topup: `${BASEURL}rest/wallet/topup`,
  topupStatusCheck: `${BASEURL}rest/wallet/topup/status-check`,
};

export const passPackage = {
  monthly: `${BASEURL}rest/pass-package/monthly`,
  monthlyAvailable: `${BASEURL}rest/pass-package/monthly/available`,
  monthlyCalculate: `${BASEURL}rest/pass-package/monthly/calculate`,
  purchaseMonthly: `${BASEURL}rest/pass-package/purchase/monthly`,
  purchaseStatusCheck: `${BASEURL}rest/pass-package/purchase/status-check`,
};

export default rider;
